enum ReserveLivingStatus {
    OnReserve,
    OffReserve,
    OnAndOffReserve
}

enum IndigenousIdentityStatus {
    NonStatus = 0,
    Status = 1,
    Pending = 2
}

class BritishColumbiaObstetricalFileIndigenousIdentity {
    public NoResponse: boolean;
    public NoIndigenousIdentity: boolean;
    public IsFirstNations: boolean;
    public IsMetis: boolean;
    public IsInukInuit: boolean;
    public IsOutsideCanada: boolean;
    public HasStatus?: IndigenousIdentityStatus;
    public ReserveLivingStatus: ReserveLivingStatus;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileIndigenousIdentity>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileIndigenousIdentity, IndigenousIdentityStatus, ReserveLivingStatus };
